const {Component} = require("react");
const PropTypes = require("prop-types");
const LocationField = require("app/components/fields/Location");
const ZipCityField = require("app/components/fields/ZipCity");
const PikadayField = require("app/components/fields/Pikaday");
const moment = require("moment");
const Trans              = require('app/components/trans/Trans')

class DeliveryWidget extends Component {

	static get propTypes() {
		return {
			title: PropTypes.string,
			address: PropTypes.string,
			zip: PropTypes.string,
			city: PropTypes.string,
			date: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			title: translate("MODTAGERS ADRESSE VED UBRINGNING")
		};
	}

	constructor(props) {
		super(props);
		this.state = {
          address: props.address,
          zip: props.zip,
          city: props.city,
          region: props.region,
          date: props.date
        };
	}

	_onAddressChange = (e) => {
		this.setState({address: e.target.value});
	};

	_onZipChange = (zip, city) => {
		this.setState({zip, city});
	};

	_onDateChange = (date) => {
		this.setState({date: moment(date).format("YYYY-MM-DD")});
	};

	renderAddress() {
		return (
			<LocationField placeholder={ translate ( "Adresse" ) } defaultValue={this.props.address} onInput={this._onAddressChange}/>
		);
	}

	renderZip() {
      return (
        <ZipCityField zip={this.state.zip} city={this.state.city} region={this.state.region}
                      onChange={this._onZipChange}/>
      );
    }

	renderDate() {
		return (
			<PikadayField placeholder={ translate("Dato for levering")} min={moment().format("YYYY-MM-DD")} value={this.state.date}
										onChange={this._onDateChange}/>
		);
	}

	renderActions() {
		return (
			<div className="actions">
              <button className="btn"> <Trans> NY MODTAGER ADRESSE </Trans> </button>
				<button className="btn primary"> <Trans> LÆG I KURVEN </Trans> </button>
			</div>
		);
	}

	render() {
		return (
			<div className="delivery-widget">
				<div className="title">{this.props.title}</div>
				{this.renderAddress()}
				{this.renderZip()}
				{this.renderDate()}
				{this.renderActions()}
			</div>
		);
	}

}

module.exports = DeliveryWidget;
